import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud(
	'hr_category',
	'Categoria recursos humanos',
	'Categorias recursos humanos'
)

const createHRCategory = (item, options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/hr_category/create_hr_category`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				hr_category: item,
			}),
			successMessage: `Se agregó la categoría correctamente.`,
		})
		showSuccessMessage('Las categorías se registrarón correctamente')
		dispatch({
			type: 'ADD_HR_CATEGORY',
			response: res.body.hr_category,
		})
		return res.body.hr_category
	}
}

const updateHRCategory = (item, options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/hr_category/update_hr_category`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				hr_category: item,
			}),
			successMessage: `Se agregó la categoría correctamente.`,
		})
		showSuccessMessage('Las categorías se registrarón correctamente')
		dispatch({
			type: 'UPDATE_HR_CATEGORY',
			response: res.body.hr_category,
		})
		return res.body.hr_category
	}
}

export default { ...actions, createHRCategory, updateHRCategory }
